import React, { Component } from 'react'
import Icon from './Icon'

class Dash extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg viewBox='0 0 24 24' className='icon__fill'>
          <rect width='11.041' height='1.627' x='6' y='11' fillRule='evenodd' />
        </svg>
      </Icon>
    )
  }
}

export default Dash
